export default "__VITE_ASSET__Raoc9OyV__"